import { render, staticRenderFns } from "./plug.vue?vue&type=template&id=0fb9787c&scoped=true"
import script from "./plug.vue?vue&type=script&lang=js"
export * from "./plug.vue?vue&type=script&lang=js"
import style0 from "./plug.vue?vue&type=style&index=0&id=0fb9787c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb9787c",
  null
  
)

export default component.exports